import React, { useState, useEffect, useCallback } from "react";
import { default as pdfFileApi } from './../../common/serviceApi'
import miiPdfHeader from '../../assets/images/NewHeader.png';
import miiPdfFooter from '../../assets/images/NewFooter.png';
import { Document, Page, Image, View, StyleSheet, Text ,pdf } from '@react-pdf/renderer';
import { useAuth } from "../../auth/AutoContextProvider";
import { useCommon } from "../CommonServiceProvider";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "1cm",
    paddingTop: 30,
    paddingBottom: 60,
    paddingHorizontal: 30,
    fontSize: 12,
    lineHeight: 1.5,
    fontFamily: 'Helvetica',
    fontWeight: 'lightweight'
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 60,
    backgroundColor: '#F5F5F5',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 60,
    backgroundColor: '#F5F5F5',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: 1,
    paddingTop: 50,
    paddingBottom: 50
  },
  image: {
    width: '100%',
    height: '100%',
  },
  heading: {
    marginTop: 10,
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bolder',
  },
});

const PdfViewer = ({ text, role, disabled, formData , uId, onClick, emailStatus, setEmailStatus }) => {
  const [_, {sso, getCookie, getFinalGuestToken}]= useAuth()
  const [{sendEmail, refreshLimitToken }]= useCommon()
  const [hoveredBuildMii, setHoveredBuildMii] = useState(false);
  const [loading, setLoading] = useState(false);
  const refresh = getCookie('tkn-ath-rfrsh')

  const [jobTitle, setJobTitle] = useState('')
  const [roleDescription, setRoleDescription] = useState('')
  const [responsibilities, setResponsibilities] = useState('')
  const [results, setResults] = useState('')
  const [requirements, setRequirements] = useState('')


  useEffect(() => {
    const sectionObject = {
      jobTitle: "",
      roleDescription: "",
      responsibilities: "",
      results: "",
      requirements: ""
    }

    const jobTitleRegex = /Role: (.+)/
    const jobTitleMatch = text.match(jobTitleRegex)
    sectionObject.jobTitle = jobTitleMatch ? jobTitleMatch[1].trim() : ""

    const roleDescriptionRegex = /Role: (.+)\s*([\s\S]*?)\s*(?:Responsibilities:|$)/
    const roleDescriptionMatch = text.match(roleDescriptionRegex)
    sectionObject.roleDescription = roleDescriptionMatch ? roleDescriptionMatch[2].trim() : ""

    const responsibilitiesRegex = /Responsibilities:\s*([\s\S]*?)\s*Results:/
    const responsibilitiesMatch = text.match(responsibilitiesRegex)
    sectionObject.responsibilities = responsibilitiesMatch ? responsibilitiesMatch[1].trim() : ""

    const resultsRegex = /Results:\s*([\s\S]*?)\s*Requirements:/
    const resultsMatch = text.match(resultsRegex)
    sectionObject.results = resultsMatch ? resultsMatch[1].trim() : ""

    const requirementsRegex = /^Requirements:\n+([\s\S]+)/m
    const requirementsRegex2 = /^Requirements:[\s\n]+([\s\S]+)/m;
    const requirementsMatch = text.match(requirementsRegex) || text.match(requirementsRegex2)
    sectionObject.requirements = requirementsMatch ? requirementsMatch[1].trim() : ""

    const isNotEmpty = Object.values(sectionObject).every(value => value.trim() !== "")
    
    if (sectionObject) {    
      setJobTitle(sectionObject.jobTitle)
      setRoleDescription(sectionObject.roleDescription)
      setResponsibilities(sectionObject.responsibilities)
      setResults(sectionObject.results)
      setRequirements(sectionObject.requirements)

    } else {
      setJobTitle('')
      setRoleDescription('')
      setResponsibilities('')
      setResults('')
      setRequirements('')
    }
  }, [text]);

  const savePdf = useCallback(async(blob,role,uId) => {
    setLoading(true)
    const fileObj = new Promise((resolve, reject) => {
      const key = `job-description-templates/${uId}/job-description-${role}`
      refreshLimitToken(refresh)
      .then((response) =>{
        const fetchFile = pdfFileApi.get(`s3/signed-url?key=${key}&expires=500&type=pdf`)
        .then((response) => {

          if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
            sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
          }
          return fetch(response?.data?.signedUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': blob?.type
            },
            body: blob,
          }).then(() => {
            return {
              name: `${role}-job-description.pdf`,
              size: blob?.size,
              awsFilePath: response?.data?.publicUrl
            }
          })
          .catch(error => {
            console.log("error",error)
            setLoading(false)
            refreshLimitToken(refresh)
            reject(error);
          })
        })
        .catch(error=>{
          console.log("error",error)
          setLoading(false)
          refreshLimitToken(refresh)
        })
        return resolve(fetchFile)
      })
    })
    .then((response)=>{
      if(response && formData) {
        const payload = {
          "template": "Worldify-Welcome-Email",
          "send_to": `${formData.email}`,
          "contents": {
            "name": `${formData.name}`,
            "document_link": `${response.awsFilePath}`
          }
        }
        sendEmail(payload)
        .then((response) => {
          if(response?.status == 200) {
            setEmailStatus('success')
          }else{
            setEmailStatus('fail')
          }
          if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
            sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
          }
          setLoading(false)
          onClick(true)

        })
        .catch((error) => {
          setLoading(false)
          refreshLimitToken(refresh)
          onClick(true)
          setEmailStatus('fail')
        })
      }
    })
    return fileObj
  })

  const MyDocument = () => {
    return(
      <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image style={styles.image} src={miiPdfHeader} />
        </View>
        <View style={styles.body}>
          <Text>
            <Text style={styles.heading}>{`Role: ${jobTitle}`}</Text>
          </Text>
          <Text>{roleDescription}</Text>
          <Text style={styles.heading}>{`Responsibilities:`}</Text>
          <Text>{responsibilities}</Text>
          <Text style={styles.heading}>{`Results:`}</Text>
          <Text>{results}</Text>
          <Text style={styles.heading}>{`Requirements:`}</Text>
          <Text>{requirements}</Text>
        </View>
        <View style={styles.footer}>
          <Image style={styles.image} src={miiPdfFooter} />
        </View>
      </Page>
    </Document>
    )
  };

  const handleExport = () => {
    const blob = pdf(<MyDocument />).toBlob();
    blob.then((blob) =>{
      savePdf(blob,role,uId)
    })
    .catch((error) => {
      console.error("Error Generating PDF:", error);
    })
  };

  const handleHovering = (isHovered) => {
    setHoveredBuildMii(isHovered);
  };

  return (
    //   <button
    //    className={`${disabled ? "bg-gray-300" : hoveredBuildMii ? "bg-blue-700" : "bg-gradient-to-r from-themeColor-200 to-themeColor-100"}  text-white-700 font-bold py-2 px-4 rounded-full`}
    //    disabled={disabled}
    //    onMouseEnter={() => handleHovering(true)}
    //    onMouseLeave={() => handleHovering(false)}
    //    onClick={handleExport}
    //  >
    //    {loading ? (
    //     <div className="border-[4px] border-gray-700 border-t-blue-600 animate-spin h-[2rem] w-[2rem] rounded-[50%]" />
    //   ) : (
    //     "Send"
    //   )}
    //  </button>
    <button
    className={`${
      disabled ? "bg-gray-300" : hoveredBuildMii ? "bg-blue-700" : "bg-gradient-to-r from-themeColor-200 to-themeColor-100"
    } text-white-700 font-bold py-2 px-4 rounded-full`}
    disabled={disabled || loading} // Disable the button while loading
    onMouseEnter={() => handleHovering(true)}
    onMouseLeave={() => handleHovering(false)}
    onClick={handleExport}
  >
    {loading ? (
      <div className="border-[4px] border-gray-700 border-t-blue-600 animate-spin h-[2rem] w-[2rem] rounded-[50%]" />
    ) : (
      "Send"
    )}
  </button>
  );
};

export default PdfViewer;
